import { render, staticRenderFns } from "./SocialNetworkPosts.vue?vue&type=template&id=8923a446&"
import script from "./SocialNetworkPosts.vue?vue&type=script&lang=js&"
export * from "./SocialNetworkPosts.vue?vue&type=script&lang=js&"
import style0 from "./SocialNetworkPosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports